import { useEffect, useState } from "react";

// routing
import Routes from "routes";

// project imports
import Locales from "ui-component/Locales";
import NavigationScroll from "layout/NavigationScroll";
import RTLLayout from "ui-component/RTLLayout";
import Snackbar from "ui-component/extended/Snackbar";
import Loader from "ui-component/Loader";

import ThemeCustomization from "themes";
import { dispatch } from "store";
import { getDashboard } from "store/slices/menu";

// auth provider
import { FirebaseProvider as AuthProvider } from "contexts/FirebaseContext";

// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
// import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';

// ==============================|| APP ||============================== //

const App = () => {
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    dispatch(getDashboard()).then(() => {
      setLoading(true);
    });
  }, []);

  useEffect(() => {
    const handleRouteChange = () => {
      const favicon =
        document.querySelector<HTMLLinkElement>('link[rel="icon"]');
      if (favicon) {
        favicon.href = "/favicon.svg";
      }
    };

    window.addEventListener("popstate", handleRouteChange);

    return () => {
      window.removeEventListener("popstate", handleRouteChange);
    };
  }, []);

  useEffect(() => {
    const clearStorage = (): void => {
      const session = sessionStorage.getItem("flag");

      if (session === null) {
        localStorage.clear();
      }
      sessionStorage.setItem("flag", "1");
    };

    window.addEventListener("load", clearStorage);

    return () => {
      window.removeEventListener("load", clearStorage);
    };
  }, []);

  if (!loading) return <Loader />;

  return (
    <ThemeCustomization>
      <RTLLayout>
        <Locales>
          <NavigationScroll>
            <AuthProvider>
              <>
                <Routes />
                <Snackbar />
              </>
            </AuthProvider>
          </NavigationScroll>
        </Locales>
      </RTLLayout>
    </ThemeCustomization>
  );
};

export default App;
